module.exports = __webpack_public_path__ + "img/vertical_shine.8bce2623.png";